<template>
  <div class="searchForm">
    <div v-if="isLoading">
        <lottie-player src="https://assets6.lottiefiles.com/packages/lf20_nvskuoaw.json"  background="transparent" class="customProgress"  speed="1"  style="width: 300px; height: 300px;"    autoplay></lottie-player>
    </div>
    <div v-else>
      <Toast />
      <!-- <section class="box">
                <h2>Phiếu liên lạc điện tử</h2>
                <img :src="dataSet['Link Logo'] != '' ? dataSet['Link Logo'] : ''" :alt="dataSet['Tên trung tâm']" v-if="dataSet">
                <h4 v-if="dataSet">{{ dataSet['Tên trung tâm'] != '' ? dataSet['Tên trung tâm'] : ''}}</h4>
                <div class="p-grid p-jc-center" style="margin-left:15px; margin-right:15px">
                    <div class="p-col-8 p-sm-4 p-md-3 p-xl-3 p-lg-3">
                        <div class="item">
                            <label for="name">Họ và tên học sinh</label>
                            <div class="p-field p-inputgroup">
                                <InputText placeholder="" class="name" v-model="name"/>
                                <span class="p-inputgroup-addon">
                                    <i class="pi pi-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-8 p-sm-4 p-md-3 p-xl-3 p-lg-3">
                        <div class="item">
                            <label for="name">Số điện thoại phụ huynh</label>
                            <div class="p-inputgroup">
                                <InputText id="withoutgrouping" type="number" :useGrouping="false" v-model="phone" maxlength="12"/>
                                <span class="p-inputgroup-addon">
                                    <i class="pi pi-phone"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
      <section class="box">
        <h2>Phiếu liên lạc điện tử</h2>
        <img
          :src="dataSet['Link Logo'] != '' ? dataSet['Link Logo'] : ''"
          :alt="dataSet['Tên trung tâm']"
          v-if="dataSet"
        />
        <h4 v-if="dataSet">
          {{ dataSet["Tên trung tâm"] != "" ? dataSet["Tên trung tâm"] : "" }}
        </h4>
        <div class="p-d-flex p-flex-column p-col-12 p-sm-6 p-lg-3 p-mx-auto">
          <div class="item">
            <label for="name">Họ và tên học sinh</label>
            <div class="p-field p-inputgroup">
              <InputText placeholder="" class="name" v-model="name" />
              <span class="p-inputgroup-addon">
                <i class="pi pi-user"></i>
              </span>
            </div>
          </div>
          <div class="item">
            <label for="name">Số điện thoại phụ huynh</label>
            <div class="p-field p-inputgroup">
              <InputText
                id="withoutgrouping"
                type="number"
                :useGrouping="false"
                v-model="phone"
                maxlength="12"
              />
              <span class="p-inputgroup-addon">
                <i class="pi pi-phone"></i>
              </span>
            </div>
          </div>
          <div class="item">
            <label for="object">Lựa chọn môn học</label>
            <div class="p-field p-inputgroup">
              <Dropdown
                v-model="selectSubject"
                :options="subjects"
                optionLabel="Môn"
                placeholder="Chọn môn học"
                optionValue="Môn"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="p-grid p-jc-center">
          <Button
            type="button"
            label="Tìm kiếm"
            icon="pi pi-search"
            iconPos="right"
            @click="searchButtonClick()"
          />
        </div>
      </section>
      <footer>
        <a href="http://gv.megaedu.vip">Một sản phẩm của Megaedu</a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Homepage",
  components: {},
  data() {
    return {
      date: null,
      name: null,
      phone: null,
      selectSubject: null,
      subjects: [],
      centerName: null,
      dataSet: null,
      rangeYear: "",
      valueProgress: 0,
      isLoading: false,
    };
  },
  watch: {},
  created() {
    this.getCenter();
    this.makeRangeYear();
    this.getSubjects();
  },
  methods: {
    getSubjects() {
      this.isLoading = true;
      this.startProgress();
    //   Only use url in v2
    //   let url = "https://api.megacare.top/find";
    let url = this.$urlAPI
      this.axios({
        method: "post",
        url: url,
        data: JSON.stringify({ mode: "MonHoc"}),
        headers: {
          "Content-Type": "application/json",
        },
        auth: this.$auth,
      })
        .then((result) => {
          let data = result.data ? result.data.data : [];
          this.subjects = data
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error Message",
            detail: "Err" + err,
            life: 3000,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.endProgress();
        });
    },
    makeRangeYear() {
      let date = new Date();
      let year = date.getUTCFullYear();
      let pastYear = parseInt(year) - 40;
      this.rangeYear = "" + pastYear + ":" + year;
    },
    getCenter() {
      // get URL parent domain redirect
      let urlOrigin = window.document.referrer;
      // console.log('parrent url: ' + urlOrigin)
      let url = "";
      if (urlOrigin.includes("/")) {
        url = urlOrigin.split("/");
      }

      // Get router
      // pass data to bodyForm
      let bodyFormData = {
        mode: "getLogo",
        domain: url[2],
        // domain: 'home.ttlyhoangle.com'
      };
      this.axios({
        method: "post",
        url: this.$urlAPI,
        data: JSON.stringify(bodyFormData),
        headers: {
          "Content-Type": "application/json",
        },
        auth: this.$auth,
      })
        .then((response) => {
          if (response.data.status == "false") {
            this.$toast.add({
              severity: "error",
              summary: "Error Message",
              detail: "Dữ liệu không tồn tại",
              life: 3000,
            });
          } else {
            this.dataSet = response.data;
            this.centerName = this.dataSet["Tên trung tâm"];
          }
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error Message",
            detail: "Err" + err,
            life: 3000,
          });
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    checkFormHasValue() {
      if (this.phone == null && this.name == null) {
        this.$toast.add({
          severity: "error",
          summary: "Error Message",
          detail: "Bạn phải nhập dữ liệu cần tìm vào form",
          life: 3000,
        });
        return false;
      } else {
        // if ((this.date !== null && this.phone !== null && this.name ==null) || (this.date !== null && this.phone == null && this.name !== null) || (this.date == null && this.phone !== null && this.name !== null) || (this.date !== null && this.phone !== null && this.name !== null)){
        if (this.name != "" && this.phone != "") {
          return true;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error Message",
            detail: "Bạn phải điền ít nhất 2 hoặc 3 trường dữ liệu vào",
            life: 3000,
          });
          return false;
        }
      }
    },
    searchButtonClick() {
      if (this.checkFormHasValue()) {
        this.$router.push({
          name: "Info",
          params: {
            name: this.name,
            centerName: this.centerName,
            phone: this.phone,
            subject: this.selectSubject,
          },
        });
      }
    },
    startProgress() {
      this.interval = setInterval(() => {
        let newValue = this.valueProgress + Math.floor(Math.random() * 10) + 1;
        if (newValue >= 100) {
          newValue = 100;
        }
        this.valueProgress = newValue;
      }, 2000);
    },
    endProgress() {
      clearInterval(this.interval);
      this.interval = null;
    },
  },
};
</script>

<style>
#app {
  height: 100%;
}

.customProgress{
    position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.searchForm {
  background-image: url("./../../assets/background-search-page.png");
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
  height: 100%;
  background-position: center;
}
.searchForm .item input {
  background: #fff;
  text-align: center;
}
.searchForm .item .p-inputgroup-addon {
  background: #007bff;
  color: #fff;
  border: 0px;
}
.p-datepicker table td {
  padding: 0;
}
.searchForm .box {
  padding-top: 20px;
  margin-bottom: 20px;
}
.searchForm .box img {
  width: 15%;
}
.searchForm .p-inputnumber {
  width: 100%;
}
.searchForm footer {
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: teal;
  color: #fff;
  padding-top: 5px;
  padding-bottom: 5px;
}
.searchForm footer a {
  text-decoration: none;
  color: #fff;
  font-size: 18px;
}
/* Responsive */
@media only screen and (max-width: 575px) {
  .searchForm .box img {
    width: 25%;
  }
}
</style>